var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation } from '@apollo/client/react';
import { FileSystemDocumentDownloadFormat } from 'shared/domains/apollo/generated/types';
import { GetAttachmentDocument } from './GetAttachment.gql';
export const useGetAttachments = () => {
    var _a, _b;
    const [mutate] = useMutation(GetAttachmentDocument);
    const downloadFormat = FileSystemDocumentDownloadFormat.Pdf;
    const appUrl = (_b = (_a = process.env.RENDER_SERVICE_CSS_FILE_APP_URL) !== null && _a !== void 0 ? _a : process.env.APP_URL) !== null && _b !== void 0 ? _b : window.location.origin;
    const cssUrl = new URL('/public/pdf.css', appUrl).toString();
    const isUploaded = (attachment) => attachment !== null;
    const getAttachment = (documentId) => __awaiter(void 0, void 0, void 0, function* () {
        const input = { documentId, cssUrl, downloadFormat };
        const { data } = yield mutate({ variables: { input } });
        if (!(data === null || data === void 0 ? void 0 : data.downloadFileSystemDocument)) {
            return null;
        }
        return {
            name: data.downloadFileSystemDocument.name,
            path: data.downloadFileSystemDocument.path,
            type: data.downloadFileSystemDocument.type,
        };
    });
    const getAttachments = (documentIds) => __awaiter(void 0, void 0, void 0, function* () {
        const uploads = yield Promise.all(documentIds.map(getAttachment));
        const successfulUploads = uploads.filter(isUploaded);
        return successfulUploads;
    });
    return { getAttachments };
};
